<table>
  <thead>
    <tr>
      <th scope="col" *ngFor="let h of columnHeaders; trackBy: trackByIndex;" class="personalize-text">{{h?.tableHeader?.text?.resourceValue}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows; trackBy: trackByIndex;">
      <ng-template
          *ngFor="let element of row.elements"

          visiblewhen
            [layoutObject]="getLayoutObject(element)"
            [model]="model"
            [specFields]="specFields"
            [isTable]="true"
      >
        <th *ngIf="element.tableHeader" scope="row" class="personalize-text">{{element.tableHeader?.text?.resourceValue}}</th>
        <td *ngIf="!element.tableHeader" [attr.cols]="distributed ? nbrColumns : null">
          <ng-template [ngIf]="element.field">
            <lm-field *ngIf="!element.field.cfgHidden"
                [layoutObject]="element.field"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [model]="model"
                [style.width]="element.width"
                class="{{element.class}}"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-field>
          </ng-template>

          <ng-template [ngIf]="element.checkcontrol">
            <lm-checkcontrol *ngIf="!element.checkcontrol.cfgHidden"
                [layoutObject]="element.checkcontrol"
                [layoutInfo]="layoutInfo"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [model]="model"
                [style.width]="element.width"
                class="{{element.class}}"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-checkcontrol>
          </ng-template>

          <ng-template [ngIf]="element.captchaControl">
            <lm-captcha-control [layoutObject]="element.captchaControl"></lm-captcha-control>
          </ng-template>

          <ng-template [ngIf]="element.header">
            <lm-header
                [layoutObject]="element.header"
                [layoutInfo]="layoutInfo"
                [specFields]="specFields"
                [model]="model"
                [style.width]="element.width"
                class="{{element.class}}"
            ></lm-header>
          </ng-template>

          <ng-template [ngIf]="element.paragraph">
            <lm-paragraph
                [layoutObject]="element.paragraph"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [model]="model"
                [style.width]="element.width"
                class="{{element.class}}"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-paragraph>
          </ng-template>

          <ng-template [ngIf]="element.button">
            <lm-button *ngIf="!element.button.cfgHidden"
                [layoutObject]="element.button"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                [specFields]="specFields"
                [model]="model"
                [style.width]="element.width"
                class="{{element.class}}"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-button>
          </ng-template>

          <ng-container *ngIf="element.Blank">
            <div
                *ngIf="lmColumnLayoutInfo"
                lm-blankline
                class="{{element.class}}"
            ></div>
            <div *ngIf="!lmColumnLayoutInfo" lm-blankline></div>
          </ng-container>

          <ng-template [ngIf]="element.text">
            <lm-text
                [layoutObject]="element.text"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [model]="model"
                [style.width]="element.width"
                class="{{element.class}} field"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-text>
          </ng-template>

          <ng-template [ngIf]="element.menu">
            <lm-simple-card
                [type]="element.menu.type"
                [specFields]="specFields"
                [model]="model"
                [scale]="element.menu.menuScale"
                [link]="element.menu.link"
                [showBackground]="false"
                [imageUrl] = "element.menu.image"
                [title]="element.menu.label"
                [description]="element.menu.description"
                [paragraphLayout]="false"
                [isLink]="element.menu.isLink"
                [isExternalLink]="element.menu.external"
                class="{{element.class}} field"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-simple-card>
          </ng-template>
        </td>
      </ng-template>
    </tr>
  </tbody>
</table>
